import React, { useMemo, useState } from "react";
import api from "../api";

function useQuery() {
  return useMemo(() => new URLSearchParams(window.location.search), []);
}

export default function ResetPassword() {
  const q = useQuery();
  const uid = q.get('uid') || '';
  const token = q.get('token') || '';
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!uid || !token) { setError("Enlace inválido"); return; }
    if (!newPwd || !confirmPwd) { setError("Completa todos los campos"); return; }
    if (newPwd !== confirmPwd) { setError("Las claves no coinciden"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("user/password-reset/confirm/", { uid, token, new_password: newPwd, confirm_password: confirmPwd });
      if (data?.ok) setDone(true);
      else setError("No se pudo completar el cambio");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Error en el enlace o token expirado";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-6 w-full max-w-md">
        <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Restablecer contraseña</h1>
        {!done ? (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Nueva contraseña</label>
              <input type="password" value={newPwd} onChange={(e)=>setNewPwd(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" placeholder="••••••••" />
            </div>
            <div>
              <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Confirmar contraseña</label>
              <input type="password" value={confirmPwd} onChange={(e)=>setConfirmPwd(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" placeholder="••••••••" />
            </div>
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg py-2 font-medium disabled:opacity-60">
              {loading? 'Guardando…' : 'Guardar nueva contraseña'}
            </button>
          </form>
        ) : (
          <div className="text-green-700 bg-green-50 border border-green-200 rounded-lg p-4">
            Tu contraseña fue actualizada. Ya puedes iniciar sesión.
          </div>
        )}
      </div>
    </div>
  );
}
